import {Component, Injector} from '@angular/core';
import {TasksDialogBaseComponent} from "./tasks-dialog-base/tasks-dialog-base.component";
import {TasksService} from "../../../services/tasks.service";

@Component({
    selector: 'app-create-task',
    templateUrl: './tasks-dialog-base/tasks-dialog-base.component.html',
    styleUrls: ['./tasks-dialog-base/tasks-dialog-base.component.css'],
    standalone: false
})
export class CreateTaskComponent extends TasksDialogBaseComponent {

  constructor(private tasksService: TasksService,protected injector:Injector) {
    super(injector);
    this.dialogId = "createTask";
  }

  public submit() {
    this.model.Id = 0;
    this.tasksService.CreateTask(this.model)
      .subscribe((res) => {
          this.onCreated.emit();
          this.close();
          super.submit();

        });
  }
}
